module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-yellow"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.unique_users))]), _vm._v(" "), _c('p', [_vm._v("Users")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.referrals))]), _vm._v(" "), _c('p', [_vm._v("Referrals")])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-blue"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.redeemed_refferals))]), _vm._v(" "), _c('p', [_vm._v(" Redeemed Referrals")])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-purple"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.feedback_given))]), _vm._v(" "), _c('p', [_vm._v("Completed Feedback")])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('chartjs-horizontal-bar', {
    attrs: {
      "datalabel": 'Global',
      "labels": _vm.labels,
      "data": [_vm.unique_users, _vm.referrals, /*referrals_without_facilities_with_locationid + referrals_without_facilities_without_locationid,*/ /* referrals_with_facilities_with_locationid + referrals_with_facilities_without_locationid, */ _vm.redeemed_refferals, _vm.feedback_given],
      "bind": true,
      "backgroundcolor": _vm.bgcolors
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('chartjs-horizontal-bar', {
    attrs: {
      "datalabel": 'Weekly',
      "labels": _vm.labels,
      "data": [_vm.weekly_unique_users, _vm.weekly_referrals, /*weekly_referrals_without_facilities_with_locationid + weekly_referrals_without_facilities_without_locationid,*/ /* weekly_referrals_with_facilities_with_locationid + weekly_referrals_with_facilities_without_locationid, */ _vm.weekly_redeemed_refferals, _vm.weekly_feedback_given],
      "bind": true,
      "backgroundcolor": _vm.bgcolors
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('chartjs-horizontal-bar', {
    attrs: {
      "datalabel": 'Monthly',
      "labels": _vm.labels,
      "data": [_vm.monthly_unique_users, _vm.monthly_referrals, /*monthly_referrals_without_facilities_with_locationid + monthly_referrals_without_facilities_without_locationid,monthly_referrals_with_facilities_with_locationid + monthly_referrals_with_facilities_without_locationid, */ _vm.monthly_redeemed_refferals, _vm.monthly_feedback_given],
      "bind": true,
      "backgroundcolor": _vm.bgcolors
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Dashboard\n      "), _c('small', [_vm._v("Summary")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Dashboard")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Summary")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-person-stalker"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-iphone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-home"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-chatboxes"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Global")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Weekly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Monthly")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c211b272","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = +UKV
// module chunks = 1